// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BbiQu","largestCol":"styles_largestCol__ZOuWS","smallestCol":"styles_smallestCol__2nt13"};